// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

// This is where we add any polyfills we'll need for the browser. It is the entry module for browser-specific builds.

export * from "./index";
